export default __webpack_public_path__ + "static/media/explodeYT.06ccbfcc.png";